var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"is-fixed":true}}),_c('router-view',{staticStyle:{"margin-top":"6vh"},attrs:{"scrollY":_vm.scrollY}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }